import { useState, useEffect, useRef } from 'react';
import { getUserProfileApi } from '../services/authApi/userApi';
import { toastNotify } from '../utils/toastNotify';
import { addUserData, addCounter } from '../store/reducer/accountSlice';
import { useDispatch } from 'react-redux';

const useGetUserProfile = () => {
  const [respMessage, setRespMessage] = useState();
  const [userProfile, setUserProfile] = useState({});
  const [loading, setLoading] = useState(false);
  const shouldLog = useRef(true);
  const dispatch = useDispatch();

  useEffect(() => {
    if (shouldLog.current) {
      shouldLog.current = false;
      getUserProfile();
    }
  }, []);

  const getUserProfile = async () => {
    setLoading(true);
    try {
      const resData = await getUserProfileApi();
      if (!resData.isError) {
        const { data } = resData;
        setUserProfile({
          ...data?.user,
        });
        dispatch(
          addUserData({
            userData: {
              ...resData?.data?.user,
            },
          })
        );
        dispatch(addCounter(resData?.data?.counter));
      }
    } catch (error) {
      const { response } = error;
      toastNotify('error', response?.data?.message);
      setRespMessage(response?.data?.message);
    } finally {
      setLoading(false);
    }
  };
  return {
    userProfileData: userProfile,
    respMessage,
    loading,
  };
};

export default useGetUserProfile;
